module.exports = __webpack_public_path__ + "static/img/equilymate.4099e00d.png";